import styled from "styled-components";
import { Button } from "react-bootstrap";

export const ThemeButton = styled(Button)``;
